// extracted by mini-css-extract-plugin
export default {"modal":"MessageDialog_modal__HVat3","slide-down":"MessageDialog_slide-down__D6CQb"};